import { MerchantAccountStatus } from '../../core/constants';

export class MerchantProcessor {
  id: string;
  merchantId: string;
  mid: string;
  achMid: string | undefined;
  processor: string | string[];
  processorType: string | string[];
  description: string | undefined;
  amexMerchantId: string | undefined;
  status: MerchantAccountStatus;
  contactName: string | undefined;
  contactEmail: string | undefined;
  contactPhone: string | undefined;
  ein: string | undefined;
  tokenRequestorId: string | undefined;
  tokenPlatform: string | undefined;
  tokenVaultId: string | undefined;
  tokenVaultName: string | undefined;
  gateway: string | undefined;
  terminalId: string | undefined;
  cardTerminalId: string | undefined;
  ppdTerminalId: string | undefined;
  ccdTerminalId: string | undefined;
  webTerminalId: string | undefined;

  constructor(mp: Partial<MerchantProcessor>) {
    if (mp.id == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} id cannot be null`,
      );
    if (mp.merchantId == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} merchantId cannot be null`,
      );
    if (mp.mid == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} mid cannot be null`,
      );
    if (mp.processor == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} processor cannot be null`,
      );
    if (mp.processorType == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} processorType cannot be null`,
      );
    if (mp.status == null)
      throw new Error(
        `Invalid merchant processor in constructor: ${JSON.stringify(mp)} status cannot be null`,
      );

    this.id = mp.id;
    this.merchantId = mp.merchantId;
    this.mid = mp.mid;
    this.processor = mp.processor;
    this.processorType = mp.processorType;
    this.status = mp.status;
    this.description = mp.description;
    this.amexMerchantId = mp.amexMerchantId;
    this.contactName = mp.contactName;
    this.contactEmail = mp.contactEmail;
    this.contactPhone = mp.contactPhone;
    this.ein = mp.ein;
    this.tokenRequestorId = mp.tokenRequestorId;
    this.tokenPlatform = mp.tokenPlatform;
    this.tokenVaultId = mp.tokenVaultId;
    this.tokenVaultName = mp.tokenVaultName;
    this.gateway = mp.gateway;
    this.cardTerminalId = mp.cardTerminalId;
    this.terminalId = mp.terminalId;
    this.ppdTerminalId = mp.ppdTerminalId;
    this.ccdTerminalId = mp.ccdTerminalId;
    this.webTerminalId = mp.webTerminalId;
  }

  public static clone(
    p: Partial<MerchantProcessor>,
  ): Partial<MerchantProcessor> {
    return new MerchantProcessor(JSON.parse(JSON.stringify(p)));
  }

  public static createEmpty(): Partial<MerchantProcessor> {
    return {
      id: '',
      merchantId: '',
      mid: '',
      processor: '',
      processorType: '',
      cardTerminalId: '',
      ppdTerminalId: '',
      ccdTerminalId: '',
      webTerminalId: '',
      terminalId: '',
    };
  }
}
